import { createFileRoute } from '@tanstack/react-router';

import { AdminCompetitionsPage } from '@/components/admin/sport/competitions-page';
import { adminHead } from '@/lib/seo';
import { adminListCompetitionsFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/competitions')({
    component: CompetitionsRoute,
    head: () => adminHead('טורנירים', '/admin/sport/competitions'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListCompetitionsFn({ data: { limit: 50 } }),
});

function CompetitionsRoute() {
    return <AdminCompetitionsPage initial={Route.useLoaderData()} />;
}
